
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-741dfd8f&scoped=true!../../../../vue-loader/lib/selector?type=styles&index=0!./TrinityRingsSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./TrinityRingsSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-741dfd8f!../../../../vue-loader/lib/selector?type=template&index=0!./TrinityRingsSpinner.vue"),
  /* scopeId */
  "data-v-741dfd8f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/TrinityRingsSpinner.vue
// module id = 876
// module chunks = 1